export function downloadCSV(url, filename) {
  var element = document.createElement('a');

  // console.log("downloadCSV=", url, filename);

  element.setAttribute('type', `text/csv`);
  element.setAttribute('download', true);
  element.setAttribute('target', filename);
  element.setAttribute('href', url); 
  element.style.display = 'none';

  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
  return;
}